<template>
  <div class="event-item" @mouseleave="hideMenu()">
    <div v-if="eventObject.quickedit" class="event-item__contextual_container">
      <button class="qe-button" ref="button">Opcje konfiguracji</button>
      <ul ref="menu">
        <li>
          <a :href="'/node/' + eventObject.id + '/edit'" >Edytuj</a>
        </li>
      </ul>
    </div>
    <div class="event-item__content-wrapper">
      <div class="event-item__image">
        <img :src="eventObject.image" alt="">
      </div>
      <div class="event-item__content">
        <div class="title-wrapper">
          <div class="date">{{ eventObject.date }}</div>
          <div class="title">{{ eventObject.title }}</div>
          <div class="for_region" v-if="eventObject.region">{{state.Drupal.t('for')}} {{ eventObject.region }}</div>
        </div>
        <div class="description">{{ eventObject.description }}</div>
        <div class="row">
          <div class="place" v-if="eventObject.place">{{ eventObject.place }}</div>
          <a class="button" :href="eventObject.url">Zobacz szczegóły</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Event',
  props: {
    eventObject: {
      type: Object,
    },
    state: {
      type: Object,
    }
  },
  methods: {
    focusChanged(event) {
      if (this.eventObject.quickedit) {
        let type = event.type;
        let target = event.target;
        if (target.nodeName == 'BUTTON' && target.classList.contains('qe-button') && type == 'focusin') {
          this.$refs.menu.classList.add('show');
        } else if (target.nodeName == 'BUTTON' && target.classList.contains('qe-button') && type == 'focusout') {
          if (event.explicitOriginalTarget.nodeValue != "Edytuj") {
            this.$refs.menu.classList.remove('show');
          } else {
            this.$refs.menu.classList.remove('show');
            event.explicitOriginalTarget.parentElement.click()
          }
        }
      }
    },
    hideMenu() {
      if (this.$refs.menu && this.$refs.menu.classList.contains('show')) {
        this.$refs.menu.classList.remove('show');
        this.$refs.button.blur();
      }
    }
  },
  created() {
    document.addEventListener('focusin', this.focusChanged)
    document.addEventListener('focusout', this.focusChanged)
  },
  beforeDestroy() {
    document.removeEventListener('focusin', this.focusChanged)
    document.removeEventListener('focusout', this.focusChanged)
  }
}
</script>
